import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserLink, { Props as UserLinkProps } from './UserLink';
import UserLinkPopover from './UserLinkPopover';
import { isGroup } from '../helpers';

export type Props = {
  contentClassName?: string;
  withTooltip?: boolean;
  relatedItemBiData?: any;
} & UserLinkProps;

export const UserLinkWithTooltip: React.FC<React.PropsWithChildren<Props>> = ({
  user,
  className,
  contentClassName,
  biData,
  relatedItemBiData,
  withTooltip,
  ...props
}) => {
  const isMobile = useContext(MobileContext);

  // in some cases this could be null, example deviation.author
  if (!user) {
    return null;
  }

  const shouldRenderTooltip = withTooltip && !isMobile && !isGroup(user);

  if (!shouldRenderTooltip) {
    return (
      <UserLink
        user={user}
        className={classnames(className, contentClassName)}
        biData={biData}
        {...props}
      />
    );
  }

  return (
    <UserLinkPopover
      user={user}
      className={className}
      relatedItemBiData={relatedItemBiData}
      biData={biData}
    >
      <UserLink user={user} className={contentClassName} {...props} />
    </UserLinkPopover>
  );
};
UserLinkWithTooltip.displayName = 'UserLinkWithTooltip';

export default UserLinkWithTooltip;
